<div class="layoutBlock">
	<div class="columnHalf">
		<!-- #anchor dynamic field container -->	
		<ng-template #dynamicFieldSetContainer></ng-template>
	
		<res-patent-edit-basic-data 
            [(patent)]="patent"
            [hisDynamicContent]="'I18nValue.basicData'"
            [dynamicComponent]="patent._dynamicComponent">
        </res-patent-edit-basic-data>
		
		<!-- #anchor dynamic field container -->	
		<ng-template #dynamicFieldSetContainer></ng-template>
			
		<his-plam class="noPlamStyle">
			<!-- inventors are only editable within priority patent -->
			<res-patent-edit-inventors #content hisDdKey="fs.res.patent.PriorityPatent.inventors" [(ngModel)]="inventorsModel"
		        [hisDynamicContent]="'fs.res.patent.PriorityPatent.inventors'" [dynamicComponent]="patent._dynamicComponent"
	            [patent]="patent">
			</res-patent-edit-inventors>
		</his-plam>
			
		<!-- #anchor dynamic field container -->	
		<ng-template #dynamicFieldSetContainer></ng-template>
			
		<!-- organizations of patent are only editable within priority patent -->
		<res-patent-edit-registration-organizations *ngIf="isPriority()" 
			[isPriorityPatent]="isPriority()" 
			[(organizations)]="patent.organizations"
			[dynamicComponent]="patent._dynamicComponent"
			(organizationsChange)="organizationsChange($event)">
		</res-patent-edit-registration-organizations>			
		<!-- view organizations of patent for not priority patent -->
		<res-patent-edit-registration-organizations *ngIf="!isPriority()" 
			[isPriorityPatent]="isPriority()" 
			[(organizations)]="patent.priorityPatent.organizations">
		</res-patent-edit-registration-organizations>	
		
		<!-- #anchor dynamic field container -->	
		<ng-template #dynamicFieldSetContainer></ng-template>		
	</div>
	
	<div class="columnHalf">
		<!-- #anchor dynamic field container -->	
		<ng-template #dynamicFieldSetContainer></ng-template>
	
		<!-- patent family is not editable that way -->
		<res-patent-view-family [patent]="patent" ></res-patent-view-family>
		
		<!-- #anchor dynamic field container -->	
		<ng-template #dynamicFieldSetContainer></ng-template>
		
		<res-documents-edit
			[target]="'patent'"
			[targetId]="patent.id"
			[targetObjGuid]="patent.objGuid"
			[acceptedFileTypes]="'.pdf,.doc,.png,.jpg,.jpeg'"
			[documentsToSave]="documentsToSave"
			[dynamicComponent]="patent._dynamicComponent"
			*ngIf="hisBaseGlobalsService.isAnyModuleActive('HISINONERES')">
		</res-documents-edit>
		
		<!-- #anchor dynamic field container -->	
		<ng-template #dynamicFieldSetContainer></ng-template>
	</div>
	
</div>